module.exports = __webpack_public_path__ + "img/welcome.b1f2ba1b.png";